import { appContext } from "../../../../AppContext";
import { IbssPage } from "../../../../Components/Core/BasePage/IbssPage";
import Helper from "../../../../Common/Helper";
import { Relationship } from "./DataModels";
import { PagedResponse } from "@iconics/core";
import { JSX } from "react";
import { IRouterProps, withRouting } from "@iconics/components";
import { SerendieSymbol } from "@serendie/symbols";
import { Button, ButtonBar, Card, DataGrid, GridContainer, GridItem, IGridData, IGridRowsRequest, IGridRowsResponse, LayoutContainer, LayoutContent, RightButtons } from "@iconics/components";

class ListRelationships extends IbssPage<IProps, IState>
{
    constructor(props: IProps)
    {
        super(props);
        this.state = {
            canCreate: false,
            gridData: { rows: [] },
        };
    }

    public async componentDidMount(): Promise<void>
    {
        const labels = appContext().labels;
        this.pageTitle = labels.Platform_Relationship_PageTitle;

        this.setState({
            canCreate: appContext().localStorageProvider.hasRight('DATAMODEL.Relationships.Create'),
        });
    }

    private async handleRowsRequest(request: IGridRowsRequest<IRelationship>): Promise<IGridRowsResponse<IRelationship>>
    {
        const relationshipsData = await appContext().fadxPlatformApiClientV2.v2.core.byTenancy.relationships.get<PagedResponse<Relationship[]>>({
            select: Relationship,
            tenancy: appContext().tenantId,
            skipToken: request.skipToken,
            top: request.take,
            orderBy: DataGrid.toODataOrderBy(request.sorter),
        });

        return { rows: relationshipsData.value.map(i => ({
                id: i.Id,
                name: i.Name,
                description: i.Description,
                isEnabled: i.IsEnabled,
                primary2SecondaryRelation: i.Primary2SecondaryRelation,
                secondary2PrimaryRelation: i.Secondary2PrimaryRelation,
                eTag: i["@odata.etag"],
            } as IRelationship)), nextSkipToken: relationshipsData.skipToken };
    }

    public render(): JSX.Element
    {
        const labels = appContext().labels;

        return (
            <LayoutContainer>
                <LayoutContent>
                    <Card
                        title={labels.Platform_Relationship_ListTitle}
                        subTitle={labels.Platform_Relationship_ListSubTitle}
                        icon={<SerendieSymbol name='share-alt' />}
                    >
                        <GridContainer>
                            <GridItem>
                                <ButtonBar>
                                    <RightButtons>
                                        <Button
                                            size='small'
                                            styleType='ghost'
                                            leftIcon={<SerendieSymbol name='plus' />}
                                            onClick={() => this.props.navigate(`/admin/relationships/new`)}
                                            disabled={!this.state.canCreate}
                                        >
                                            {labels.Platform_CommonAction_Add}
                                        </Button>
                                    </RightButtons>
                                </ButtonBar>
                            </GridItem>
                            <GridItem>
                                <DataGrid
                                    columns={[
                                        {
                                            columnId: Helper.nameOf<Relationship>("Name"),
                                            title: labels.Relationship_Name,
                                            getCellValue: i => i.name,
                                            columnWidth: 25,
                                            sortable: true,
                                        },
                                        {
                                            columnId: Helper.nameOf<Relationship>("Description"),
                                            title: labels.Relationship_Description,
                                            getCellValue: i => i.description,
                                            columnWidth: 35,
                                            sortable: true,
                                        },
                                        {
                                            columnId: Helper.nameOf<Relationship>("IsEnabled"),
                                            title: labels.Relationship_IsEnabled,
                                            getCellValue: (i) => <SerendieSymbol name={i.isEnabled ? 'check-circle' : 'close-circle'} style={{ marginLeft: '32px' }} />,
                                            columnWidth: 10,
                                            sortable: true,
                                        },
                                        {
                                            columnId: Helper.nameOf<Relationship>("Primary2SecondaryRelation"),
                                            title: labels.Relationship_Primary2SecondaryRelation,
                                            getCellValue: i => i.primary2SecondaryRelation,
                                            columnWidth: 15,
                                            sortable: true,
                                        },
                                        {
                                            columnId: Helper.nameOf<Relationship>("Secondary2PrimaryRelation"),
                                            title: labels.Relationship_Secondary2PrimaryRelation,
                                            getCellValue: i => i.secondary2PrimaryRelation,
                                            columnWidth: 15,
                                            sortable: true,
                                        },
                                    ]}
                                    data={this.state.gridData}
                                    rowId={i => i.id}
                                    onChange={i => this.setState({ gridData: i })}
                                    onRowsRequest={i => this.handleRowsRequest(i)}
                                    onCellClicked={i => this.props.navigate(`/admin/relationships/${i.id}/edit`)}
                                />
                            </GridItem>
                        </GridContainer>
                    </Card>
                </LayoutContent>
            </LayoutContainer>
        );
    }
}

export default withRouting(ListRelationships);

export interface IProps extends IRouterProps { }

export interface IState
{
    canCreate: boolean;
    gridData: IGridData<IRelationship>;
}

export interface IRelationship
{
    id: string;
    name: string;
    description: string;
    isEnabled: boolean;
    primary2SecondaryRelation: string;
    secondary2PrimaryRelation: string;
    eTag: string;
}
